import { render } from "./TabellaMisure.vue?vue&type=template&id=24d07b43&scoped=true"
import script from "./TabellaMisure.vue?vue&type=script&lang=js"
export * from "./TabellaMisure.vue?vue&type=script&lang=js"

import "./TabellaMisure.vue?vue&type=style&index=0&id=24d07b43&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24d07b43"]])

export default __exports__